
export default {
  name: "SvgNpo",
  props: {
    color: {
      type: String,
      default: null,
    },
  },
  computed: {
    hexColor() {
      return this.$color.getHex(this.color) || 'currentColor'
    },
  },
}
